import { Data } from "./App";
import React, { memo, useEffect, useState, useContext } from "react";
import Fav from "./Fav";
import Cart from "./Cart";
import { LazyLoadImage } from "react-lazy-load-image-component";

const List = memo(() => {
  const { data, favFilter } = useContext(Data);
  const [detail, setDetail] = useState({});
  const [detailShow, setDetailShow] = useState(false);

  // スクロール固定
  const body = document.querySelector("body");
  const [bodyTop, setBodyTop] = useState(0);
  useEffect(() => {
    if (detailShow) {
      body.style.top = bodyTop * -1 + "px";
      body.classList.add("fixed");
    } else {
      body.classList.remove("fixed");
      window.scrollTo(0, bodyTop);
      body.style.top = "";
    }
  }, [detailShow]);

  // 選択した製品情報をセット、画面位置保存
  const sendDetail = (e) => {
    let selectItem = data.find(
      (item) => item.id === e.currentTarget.getAttribute("data")
    );
    setDetail(() => selectItem);
    setDetailShow(() => true);
    setBodyTop(() => window.scrollY || document.documentElement.scrollTop);
  };

  return (
    <>
      <div className="list">
        {data.length === 0 ? (
          <p className="no_item">
            {favFilter
              ? "お気に入りに登録されていません"
              : "該当製品がありません"}
          </p>
        ) : (
          <ul className="list">
            {data.map((item) => {
              return (
                <li key={item.id} data={item.id} onClick={sendDetail}>
                  <LazyLoadImage
                    src={item.url + "images/sofa_common.png"}
                    width="100%"
                    height="auto"
                    alt={item.name}
                  />
                  <div>
                    <h2 className="en bold">{item.name}</h2>
                    <p>{item.size}</p>
                    <p className="en">
                      ¥{Number(item.minprice).toLocaleString()}〜¥
                      {Number(item.maxprice).toLocaleString()}
                    </p>
                    <Fav code={item.code} size={18} />
                  </div>
                </li>
              );
            })}
            {/* モーダル表示時の背景 */}
            <div
              className={detailShow ? "modal_bg active" : "modal_bg"}
              onClick={() => setDetailShow(false)}
            ></div>
          </ul>
        )}
      </div>

      {/* ここからモーダル */}
      <div className={detailShow ? "modal active" : "modal"}>
        {/* お気に入りボタン */}
        <Fav code={detail.code} />

        {/* 閉じるボタン */}
        <span
          className="modal_close"
          onClick={() => setDetailShow(false)}
        ></span>
        <div className="modal_inner">
          {/* 製品名と価格 */}
          <div className="modal_title">
            <h2 className="en">{detail.name}</h2>
            <p>{detail.size}</p>
            <div>
              ¥<span> {Number(detail.minprice).toLocaleString()}</span> 〜 ¥
              <span> {Number(detail.maxprice).toLocaleString()}</span>
              <small> （税込）</small>
            </div>
          </div>

          {/* 切り抜き画像 */}
          <img src={detail.url + "images/sofa_common.png"} alt={detail.name} />

          {/* 製品仕様 */}
          <ul className="modal_spec">
            <li>
              <h4 className="bold">サイズ（mm）</h4>
              <p>
                W{detailShow ? detail.w?.split(" ").join("/") : null} × D
                {detailShow ? detail.d?.split(" ").join("/") : null} × H
                {detailShow ? detail.th?.split(" ").join("/") : null} 
                <br />
                SH{detailShow ? detail.sh?.split(" ").join("/") : null} SD
                {detailShow ? detail.sd?.split(" ").join("/") : null}
              </p>
            </li>
            <li>
              <h4 className="bold">座り心地</h4>
              <p>{detailShow ? detail.feeling?.split(" ").join("/") : null}</p>
            </li>
            <li>
              <h4 className="bold">カバー仕様</h4>
              <p>
                {detailShow ? (
                  <>
                    布生地：{detail.fabric}
                    <br />
                    レザー：{detail.leather}
                  </>
                ) : null}
              </p>
            </li>
          </ul>
          <ul className="modal_spec">
            <li>
              <h4 className="bold">脚</h4>
              <td></td>
            </li>
            <li className="sub">
              <h4>サイズ（mm）</h4>
              <p>{detailShow ? detail.leg?.split(" ").join("/") : null}</p>
            </li>
            <li className="sub">
              <h4>素材</h4>
              <p>
                {detailShow ? detail.legmaterial?.split(" ").join("/") : null}
              </p>
            </li>
            <li className="sub">
              <h4>カラー</h4>
              <p>{detailShow ? detail.legcolor?.split(" ").join("/") : null}</p>
            </li>
          </ul>

          {/* リンク */}
          <div className="modal_links">
            <div>
              <a href={detail.url}>詳細ページ</a>
              <form
                method="post"
                action="https://www.ny-k.co.jp/php/shopping/addshop.php"
              >
                <input type="hidden" name="mode" value="addpage" />
                <input type="hidden" name="code" value={detail.code} />
                <button>
                  <Cart />
                  カートに入れる
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
});

export default List;
